import React from "react";
import {
  FieldWrapper,
  FilterSelect,
  FilterMultiSelect,
  FilterToggle,
  FilterSortGroup,
  CompactDateInput,
  formatGroupedValues,
} from "./jobsFilterUtils";

export const ACCOUNTS_SORT_OPTIONS = [
  { value: "name", label: "Name" },
  { value: "type", label: "Type" },
  { value: "last_sign_in", label: "Last Sign In" },
  { value: "created", label: "Created" },
];

export const ACCOUNTS_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "pending", label: "Pending Activation" },
];

export function AdminAccountsFilterFields({
  focusedFieldId,
  onFocusClear,
  rolesFilterBy,
  setRolesFilterBy,
  typeFilterBy,
  setTypeFilterBy,
  selectedStatuses,
  setSelectedStatuses,
  showDeleted,
  setShowDeleted,
  sortKey,
  setSortKey,
  sortDir,
  setSortDir,
  availableRoles = [],
}) {
  const roleOpts = [
    { value: "all", label: "All Roles" },
    ...availableRoles.map((r) => ({ value: r, label: r })),
  ];

  const typeOpts = [
    { value: "Candidate", label: "Candidate" },
    { value: "FieldStaff", label: "Field Staff" },
    { value: "OutsourcedStaff", label: "Outsourced Staff" },
    { value: "Contact", label: "Contact" },
    { value: "OfficeStaff", label: "Office Staff" },
    { value: "API", label: "API" },
  ];

  return (
    <>
      <FieldWrapper
        fieldId="role"
        label="Role"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSelect
          id="admin-accounts-role"
          value={rolesFilterBy}
          onChange={setRolesFilterBy}
          options={roleOpts}
          placeholder={null}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="type"
        label="Type"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterMultiSelect
          id="admin-accounts-type"
          options={typeOpts}
          value={Array.isArray(typeFilterBy) ? typeFilterBy : typeFilterBy === "all" ? [] : [typeFilterBy]}
          onChange={(vals) => setTypeFilterBy(vals)}
          placeholder="Select Type..."
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="status"
        label="Status"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterMultiSelect
          id="admin-accounts-status"
          options={ACCOUNTS_STATUS_OPTIONS}
          value={selectedStatuses}
          onChange={setSelectedStatuses}
          placeholder="Select Status..."
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="showDeleted"
        label=""
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterToggle
          id="admin-accounts-deleted"
          label="Show Deleted"
          checked={showDeleted}
          onChange={setShowDeleted}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="sort"
        label=""
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSortGroup
          id="admin-accounts-sort"
          sortBy={sortKey}
          sortOrder={sortDir}
          onSortByChange={setSortKey}
          onSortOrderChange={setSortDir}
          sortOptions={ACCOUNTS_SORT_OPTIONS}
        />
      </FieldWrapper>
    </>
  );
}

export function buildAdminAccountsFilterChips({
  rolesFilterBy,
  typeFilterBy,
  selectedStatuses = [],
  showDeleted,
  sortDir,
}) {
  const chips = [];
  if (rolesFilterBy && rolesFilterBy !== "all") {
    chips.push({
      id: "role",
      key: "rolesFilterBy",
      fieldId: "role",
      label: `Role: ${rolesFilterBy}`,
    });
  }

  const hasTypeFilter = Array.isArray(typeFilterBy)
    ? typeFilterBy.length > 0
    : typeFilterBy !== "all" && String(typeFilterBy || "").trim() !== "";
  if (hasTypeFilter) {
    const typeLabel = Array.isArray(typeFilterBy) ? typeFilterBy.join(",") : typeFilterBy;
    chips.push({
      id: "type",
      key: "typeFilterBy",
      fieldId: "type",
      label: `Type: ${typeLabel}`,
    });
  }

  if (selectedStatuses.length > 0) {
    const formatStatus = (val) => ACCOUNTS_STATUS_OPTIONS.find((o) => o.value === val)?.label || val;
    chips.push({
      id: "status",
      key: "selectedStatuses",
      fieldId: "status",
      label: `Statuses: ${formatGroupedValues(selectedStatuses, formatStatus, 3)}`,
    });
  }

  if (showDeleted) {
    chips.push({
      id: "showDeleted",
      key: "showDeleted",
      fieldId: "showDeleted",
      label: "Show Deleted",
    });
  }

  if (sortDir !== "desc") {
    chips.push({
      id: "sortDir",
      key: "sortDir",
      fieldId: "sort",
      label: `Direction: ${sortDir === "asc" ? "Ascending" : "Descending"}`,
    });
  }

  return chips;
}
